import * as React from 'react'
import { Container } from './Container'
import { LandingPageButton } from './LandingPageButton'

import backgroundImage from '/public/img/nubrakes-brake-repair-header.jpg'
import { BgImage } from './BgImage'
type Props = {
  title: string
  subheading: string
  buttonText: string
}
export const MinorCityTitleSection: React.FC<Props> = ({ title, subheading, buttonText }) => {
  return (
    <>
      <section className="text-white py-0">
        <BgImage src={backgroundImage}>
          <Container className="text-center">
            <h1 className="title">{title}</h1>
            <p className={`subheading`}>{subheading}</p>
            <LandingPageButton buttonText={buttonText} />
          </Container>
        </BgImage>
      </section>
    </>
  )
}
